/**
 * @generated SignedSource<<22b223fdaa2fc2193f2f5abc442677d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MarkAllTicketNotificationsReadInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type markAllTicketNotificationsReadMutation$variables = {
  input: MarkAllTicketNotificationsReadInput;
};
export type markAllTicketNotificationsReadMutation$data = {
  readonly markAllTicketNotificationsRead: {
    readonly marked: number;
  } | null;
};
export type markAllTicketNotificationsReadMutation = {
  variables: markAllTicketNotificationsReadMutation$variables;
  response: markAllTicketNotificationsReadMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarkAllTicketNotificationsReadPayload",
    "kind": "LinkedField",
    "name": "markAllTicketNotificationsRead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marked",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "markAllTicketNotificationsReadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "markAllTicketNotificationsReadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a8bb6cc871ddb135b932843735cba8c0",
    "id": null,
    "metadata": {},
    "name": "markAllTicketNotificationsReadMutation",
    "operationKind": "mutation",
    "text": "mutation markAllTicketNotificationsReadMutation(\n  $input: MarkAllTicketNotificationsReadInput!\n) {\n  markAllTicketNotificationsRead(input: $input) {\n    marked\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab254d2cf38b59d5f9c36a06825625c3";

export default node;
